<template>
  <div>
<!--    <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日清评价'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
				<div class="h-thirdColumn w-newColumn">
                    <el-form-item label="时间">
                        <el-col :span="22">
                            <el-date-picker
                                    :clearable="false"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择时间"
                                    v-model="q.searchDate"
                                    style="width: 100%;"

                            ></el-date-picker>
                        </el-col>
                    </el-form-item>
					<el-form-item label="创客">
						<el-input v-model="q.userName" placeholder="请输入创客姓名/工号" :clearable="true"></el-input>
					</el-form-item>
          <el-form-item label="抢入链群" prop="lianqun">
            <brselect category="crm_lianqun" :v="q.searchLianqun" :showcode="true"
                      v-model="q.searchLianqun" clearable></brselect>
          </el-form-item>
              <el-form-item label="区域" prop="searchQuyu">
                <brselect clearable category="show_area" :v="q.searchQuyu"
                          v-model="q.searchQuyu"></brselect>
              </el-form-item>
          </div>
            <el-collapse-transition>
              <div v-show="isScreen">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="链群类型">
                <el-select filterable v-model="q.lqType" clearable placeholder="请选择"
                >
                  <el-option label="创单链群" value="0"></el-option>
                  <el-option label="体验链群" value="1"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="部门">
                <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                >
                  <el-option
                      v-for="(item,index) in deptList"
                      :key="item.dept"
                      :label="item.dept"
                      :value="item.dept">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="渠道类型">
                <el-select filterable v-model="q.field" clearable placeholder="请选择">
                  <el-option label="医疗创新" value="1"></el-option>
                  <el-option label="生命科学" value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="职位类型">
                <el-select filterable v-model="q.titleCode" clearable placeholder="请选择">
                  <el-option label="大区经理" value="DAQU"></el-option>
                  <el-option label="渠道经理" value="QUDAO"></el-option>
                </el-select>
              </el-form-item>
          </div>

            <div class="h-thirdColumn w-newColumn">
          <el-form-item label="用户类型">
            <el-select filterable v-model="q.isagent" clearable placeholder="请选择">
              <el-option label="用户" value="0"></el-option>
              <el-option label="经销商" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>
              </div>
            </el-collapse-transition>
            <!--<div class="h-formBtnOut h-columnCenter">-->
            <!--  <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>-->
            <!--  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>-->
            <!--</div>-->
          </el-form>

          <div class="l-screenBox">
            <div class="l-screen" @click="collapseChange">
              <img :src="isScreen?closeScreen:drawScreen" alt="">
              <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
            </div>
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
            </div>
          </div>

        </div>
      </div>
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          :border="true"
          stripe
          :span-method="objectSpanMethod"
		  max-height="560"
          style="width: 100%"
          >
<!--            <el-table-column prop="daquName" label="大区" width="60" :show-overflow-tooltip="true"></el-table-column>-->
            <el-table-column prop="userName" label="创客" width="70"></el-table-column>
            <el-table-column prop="quyuName" label="区域" width="60"></el-table-column>
            <el-table-column prop="deptName" label="部门" width="60"></el-table-column>
            <el-table-column prop="isagent" label="用户类型" width="80px">
              <template slot-scope="scope">
                <span v-if="scope.row.isagent == 1">
                  经销商
                </span>
                <span v-if="scope.row.isagent == 0">
                   用户
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="mc" :label="mclabel"  width="150" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <el-tooltip placement="top">
                        <div slot="content"><pre align="left"  style="max-width: 500px;" >{{scope.row.mc}}</pre></div>
                        <pre align="left" >{{scope.row.mc}}</pre>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="wc" label="本周目标" align="left" width="150" >
                <template slot-scope="scope">
                    <el-tooltip placement="top">
                        <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.wc}}</pre></div>
                        <pre align="left" >{{scope.row.wc}}</pre>
                    </el-tooltip>
                </template>
            </el-table-column>
          <el-table-column prop="lianqunName" label="抢入链群" width="80" ></el-table-column>

          <el-table-column prop="customerName" label="客户名称" width="130" ></el-table-column>

            <el-table-column prop="visitContent" :label="vclabel"  width="150" >
                <template slot-scope="scope">
                    <el-tooltip placement="top">
                        <div slot="content"><p  align="left">{{scope.row.customerName}}</p>
                            <pre  align="left" style="max-width: 500px;">{{scope.row.visitContent}}</pre></div>
                        <div><p align="left">{{scope.row.customerName}}</p>
                            <pre align="left">{{scope.row.visitContent}}</pre></div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="dc" :label="dclabel"  :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <el-tooltip placement="top">
                        <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.dc}}</pre></div>
                        <pre align="left" >{{scope.row.dc}}</pre>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="co" label="预实差分析"  width="160">
                <template slot-scope="scope">
<!--                    <el-input class="h-tableInput" v-model="scope.row.comment" :clearable="true"></el-input>-->
                    <el-input type="textarea" v-model="scope.row.co" placeholder="请输入" class="h-txtareaBox" rows = "4" ></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="sysScore" label="评价"  width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <brselect class="h-tableInput" category="userCareLevel" :v="scope.row.sysScore" v-model="scope.row.sysScore"/>
                </template>
            </el-table-column>
            <template v-for="(column, index) in pjList">
                <el-table-column
                        v-bind="column"
                        :label="column.value"
                        :prop="column.key"
                >
                    <template scope="scope">
                        <span v-if="scope.row[column.value]  == '90' ">
                            A
                        </span>
                        <span v-if="scope.row[column.value]  == '60' ">
                            B
                        </span>
                        <span v-if="scope.row[column.value]  == '50' ">
                            C
                        </span>
                        <span v-if="scope.row[column.value]  == '0' ">
                            D
                        </span>
                        <span v-if="scope.row[column.value]  == '-1' ">
                            请假
                        </span>
                    </template>
                </el-table-column>
            </template>

<!--          <el-table-column-->
<!--            label="操作"-->
<!--            fixed="right"-->
<!--            width="150"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--				<div style="text-align: left;">-->
<!--					<el-button-->
<!--					   type="text"-->
<!--					   size="small"-->
<!--					   class="h-tableLink h-btn"-->
<!--					   @click="showDetail(scope.row.id)"-->
<!--					 >查看</el-button>-->
<!--                    <el-button-->
<!--                            type="text"-->
<!--                            size="small"-->
<!--                            class="h-tableLink h-btn"-->
<!--                            @click="updateDetail(scope.row.id)"-->
<!--                    >编辑</el-button>-->
<!--                    <el-button-->
<!--                            type="text"-->
<!--                            size="small"-->
<!--                            style="padding: 0;"-->
<!--                            class="h-tableLink h-btn"-->
<!--                            @click="del(scope.row.id)">-->
<!--                        删除-->
<!--                    </el-button>-->
<!--                </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ" @click="saveGrade" v-if="adminFlag">调整评分</el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
export default {
  data() {
    return {
      // 展开折叠筛选
      // 展开折叠筛选
      isScreen:false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),

        mclabel :'',
        dclabel:'',
        vclabel:'',
        defaultDate :this.getNow(),
      //表单
      q: {
          searchDate:this.getNow(),
          pageSize: 10,
          pageNo: 1,
          total:0,
          cdept:'',
      },
      add:{
          year :new Date().getFullYear(),
          type : 2,
          month :new Date().getMonth()+2
      },
      isfb:1,
      showhistory:false,
      adminFlag:false,
      instid:null,
      pingfen:'暂无',
      paiming:'暂无',
      pjList:[],
      //表格
      multipleSelection: [],
      multipleSelectionDialog:[],
      tableData: [],
        lianqunList : [],
      //发布排行
      dialogFlag:false,
        spanArr: [],
      sumRank:[],
        yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
        qyearList:[],
        typeList:[{type:1,text:'月目标'},{type:2,text:'周目标'}],
        monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
        weekList :[],
        quyuList:[],
        deptList: [],
        qweekList :[],
        newDialog: false,
        showDialog:false,
        updateDialog:false,
        showloading:false,
        updateloading:false,
      nosum:'',
      nosoc:'',
        searchDate:"",
      q2: {
          pageSize: 10,
          pageNo: 1,
          total:0,
          rqstatus:'',
      },

    };
  },
  created() {
      if(this.$store.getters.hasRole('swyl_admin')||this.$store.getters.hasRole('FANGAN')
          ||this.$store.getters.hasRole('YIMIAO_PINGTAI') ||this.$store.getters.hasRole('PINGTAI')
          ||this.$store.getters.hasRole('crm_quyu') || this.$store.getters.hasRole('crm_daqu')){
        this.adminFlag = true;
      }
      this.getAllLianqun();
      this.getQuyu();
      this.getDept();
  },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    methods: {
    getNow(){
        let date = new Date(new Date().getTime() - 24*60*60*1000);

        return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+(date.getDate());
    },
    genzongLiuch(r){
      this.instid = r.instid;
      this.showhistory = true;
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //弹框表格
    handleSelectionChangeDialog(val){
      this.multipleSelectionDialog = val;
    },

        //调整评分
        saveGrade(){
            console.log("tableDate",this.tableData);
            ss.RiqPingj.tzGrade({"evalList":this.tableData,searchDate:this.searchDate}).then(rd => {
                this.$msg.msgs("调整保存成功");
                this.query();
            })


        },
        del(id){
            this.$confirm("确定要删除吗？", '提示')
                .then(_ => {
                    ss.MuBiao.del({id:id}).then(response => {
                        this.query();
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                    })
                })
                .catch(_ => {
                })
        },


        getAllLianqun(){
            ss.createMonthGoal.getAllLianqun().then(rd => {
                this.lianqunList = rd;
            })
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },
        getLianqun(q){
            ss.createMonthGoal.getLianqun(q).then(rd => {
                this.lianqunList = rd;
            })
        },
        getQuyu(){
            ss.RiqPingj.selectAllQuyu().then(rd => {
                this.quyuList = rd;
            })
        },
        showDetail(id){
            this.showDialog = true;
            this.showloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.showloading = false;
            });
        },
        updateDetail(id){
            this.updateDialog = true;
            this.updateloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.updateloading = false;
            });
        },
        query(){
        console.log(this.q)
           this.mclabel = new Date(this. q.searchDate).getMonth()+1+'月目标'
            this.dclabel = new Date(this. q.searchDate).getMonth()+1+"月"+new Date(this. q.searchDate).getDate()+"日日清"
            this.vclabel = new Date(this. q.searchDate).getMonth()+1+"月"+new Date(this. q.searchDate).getDate()+"日计划"
          ss.RiqPingj.page(this.q).then(rd => {
            this.q.total = rd.total;
            this.tableData = rd.records;
            this.getSpanArr();
            this.searchDate = this.q.searchDate;
            console.log(this.searchDate)
          });
        },
        getSpanArr() {
            this.spanArr = [];
            this.tableData.forEach((item, index) => {
                if (index === 0) {
                    this.spanArr.push(1);
                    this.position = 0;
                } else {
                    if (this.tableData[index].id && this.tableData[index].id === this.tableData[index - 1].id) {
                        this.spanArr[this.position] += 1;
                        this.spanArr.push(0);
                    } else {
                        this.spanArr.push(1);
                        this.position = index;
                    }
                }
            })

        },
        getPjList(){
            ss.RiqPingj.getPjList(this.q).then(rd => {
                this.pjList = rd.msg;
                console.log("12312312312",rd.msg);
            })
        },
        objectSpanMethod({row, column, rowIndex, columnIndex}) {

            // if ((column.label == '订单编号' || column.label == 'SAP订单号' || column.label == '经销商编码' || column.label == '经销商名称') && row.orderCategory == '2') {
            //     const _row = this.spanArr[rowIndex];
            //     const _col = _row > 0 ? 1 : 0;
            //     return {
            //         rowspan: _row,
            //         colspan: _col
            //     }
            // }else if ((column.label == '订单状态' || column.label == '操作') &&
            //     (row.status == '10' || row.orderCategory == '2')) {
            //     const _row = this.spanArr[rowIndex];
            //     const _col = _row > 0 ? 1 : 0;
            //     return {
            //         rowspan: _row,
            //         colspan: _col
            //     }
            // } == this.mclabel
            //if(column.label == '抢入链群'|| column.label == '创客'
            if(columnIndex !=7 && columnIndex !=6 && columnIndex !=8
            //  if(columnIndex ==1 && columnIndex ==2 && columnIndex ==3 && columnIndex ==4 && columnIndex ==7
                // || column.label.indexOf("月目标") != -1  || column.label == '本周目标'|| column.label == '评价'
                //  || column.label == '预实差分析'
                ){
                const _row = this.spanArr[rowIndex];

                const _col = _row > 0 ? 1 : 0;
                //console.log("_row:"+_row+"-_col:"+_col)
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }

        },
        create(){

            this.newDialog = true;
        },
//取消按钮
        exit() {
            this.newDialog = false;
            this.showDialog = false;
            this.updateDialog = false;
        },
    handleFilter() {
      this.query();
      this.getPjList();
    },
      collapseChange(){
        this.isScreen = !this.isScreen;
      },
    checkRank() {
      this.$router.push("/paiming");
    },

    typeIndex(index){
      return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
    },

    //明细导出
			exportExcel() {
                //updownfile.down("/api/swyl/v1/riqing/userDailyEval/downloadExcel",this.q,"post",'data');
                ss.RiqPingj.downloadBatchExcel(this.q).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `日清评价.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
      },

    //重置
    rest() {
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q=     {
            searchDate:new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-"+(new Date().getDate()-1),
                pageSize: 10,
                pageNo: 1,
                total:0,
        }
    },
  },
  mounted() {
    this.query();
    this.getPjList();
  }
};
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
	.ljjcaozuo .el-button [class*=el-icon-]+span{
		margin-left: 0;
	}
	.ljjcaozuo .h-el-icon{
		margin-right: 0;
	}
	.smTableRq .el-table tbody td .cell {
	    padding-top: 0.03rem;
	    padding-bottom: 0.03rem;
	}
	.smTableRq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.smTableRq .el-input__inner{
		background: transparent;
	}
	.ljjtablepaddingsrq .h-tableInput{
		margin-top: 0.05rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
		color: #616467;
		font-size: 0.16rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}

    .X-dai .h-formbLine .h-elformWrap-2 {
        padding-right: 0.5rem;
        width: 50% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-3 {
        padding-right: 0.5rem;
        width: 47% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 {
        padding-right: 0;
        width: 100% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__label{
        width: 16%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__content{
        width: 82%;
    }
    .X-dai .h-formbLine .el-form-item__label {
        width: 51%;

    }
    .X-dai .h-formbLine .el-form-item__content {
        width: 49%;
    }
    pre {
        display: block;
        font-family: inherit;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        padding: 0;
        margin: 0;
        line-height: inherit;
        color: inherit;
        word-break: break-all;
        background-color: transparent;
        border: none;
        border-radius: 0;
    }
</style>
